import { observable } from "mobx";
import { Type } from "class-transformer";
import CameraResponse from "./cameraResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class GatewayResponse {
  id!: string;

  @observable
  externalGatewayIdent!: string;

  @observable
  ipAddress!: string;

  @observable
  gpsLatitude!: number;

  @observable
  gpsLongitude!: number;

  @observable
  description!: string;

  @observable
  roadId!: string;

  @observable
  regionId!: string;

  @observable
  municipalityId!: string;

  @observable
  closestToBorderWithCountryId?: string;

  @observable
  isTollRoadSection!: boolean;

  @observable
  kilometerMarker!: number;

  @observable
  @Type(() => Date)
  updatedAt!: Date;

  @observable
  isDeleted!: boolean;

  @observable
  @Type(() => CameraResponse)
  cameras!: CameraResponse[];
}
